// let http=$axios
import http from "./request";



// 左侧导航的接口
export const navList = (params, SSOID) =>
  http({
    method: "get",
    url: "/apis/hmcsAdmin/user/getAuthority?SSOID=" + SSOID,
    params: params,
  });